import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import { forword, moeHoldComment } from "../../actions/studensts";
import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API from "../../api";

export default function ActionButtonsMoeHold() {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading1, setLoading1] = useState(false);

  const { id } = useParams();
  const location = useLocation();
  const element = location.state;

  // Local state for comment/reason (updated after save)
  const [holdComment, setHoldComment] = useState(element?.moe_hold || "");
  const [holdReason, setHoldReason] = useState(element?.moe_hold_reason || "");
  const [holdFile, setHoldFile] = useState(element?.moe_hold_file || "");

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalComment, setModalComment] = useState(holdComment);
  const [modalReason, setModalReason] = useState(holdReason);
  const [modalFile, setModalFile] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState("");
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  // Fetch PDF with auth token when opening viewer
  useEffect(() => {
    if (showPdfModal && holdFile) {
      API.get(`/moe_hold/download/${holdFile}`, {
        responseType: "blob",
      }).then((res) => {
        const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        setPdfBlobUrl(url);
      }).catch(() => setPdfBlobUrl(null));
    } else {
      if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
      setPdfBlobUrl(null);
    }
    return () => {
      if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
    };
  }, [showPdfModal, holdFile]);

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading1(false);
    }, 2000);
  }

  const openModal = () => {
    setModalComment(holdComment);
    setModalReason(holdReason);
    setModalFile(null);
    setModalError("");
    setShowModal(true);
  };

  const handleSaveComment = async () => {
    if (!modalReason) {
      setModalError("Please select a Reason");
      return;
    }
    if (!modalComment) {
      setModalError("Can't save without a Comment");
      return;
    }
    setModalLoading(true);
    setModalError("");

    const formData = new FormData();
    formData.append("id", id);
    formData.append("moe_hold", modalComment);
    formData.append("moe_hold_reason", modalReason);
    formData.append(
      "moe_hold_user",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username
    );
    if (modalFile) {
      formData.append("moe_hold_file", modalFile);
    }

    const res = await moeHoldComment(formData);
    setModalLoading(false);
    if (res.status === 200) {
      setHoldComment(modalComment);
      setHoldReason(modalReason);
      if (modalFile) setHoldFile(modalFile.name);
      setShowModal(false);
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setModalError(res?.data?.ERROR || "Failed to save");
    }
  };

  const handleForwardToMoe = async () => {
    setLoading1(true);
    const res = await forword(
      id,
      "moe/",
      "moe",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  return (
    <>
      <div className="py-3 text-center">
        {showSuccessAlert && <AlertSuccess text={text} />}
        {showDengerAlert && <AlertDenger text={text} />}

        {/* MOE Hold Info */}
        {(holdComment || holdReason || holdFile) && (
          <div className="p-3 mb-3 border rounded bg-yellow-50 text-left">
            <h3 className="font-bold text-yellow-800 mb-2">MOE Hold Info</h3>
            {holdReason && (
              <p className="text-sm"><span className="font-semibold">Reason:</span> {holdReason}</p>
            )}
            {holdComment && (
              <p className="text-sm"><span className="font-semibold">Comment:</span> {holdComment}</p>
            )}
            {holdFile && (
              <p className="text-sm flex items-center gap-2">
                <span className="font-semibold">Attached File:</span>{" "}
                <button
                  className="text-blue-600 underline cursor-pointer bg-transparent border-none p-0"
                  onClick={() => setShowPdfModal(true)}
                >
                  View PDF
                </button>
              </p>
            )}
          </div>
        )}

        {(!holdComment || !holdReason || !holdFile) && (
          <p className="text-sm text-red-500 italic px-2 pt-2">
            Note: To enable buttons you should add Reason, Comment, and PDF.
          </p>
        )}

        <div className="flex flex-wrap justify-between p-2">
          <div className="p-2">
            <Button
              color="bg-yellow-600"
              onClick={openModal}
              text="Comment & Reason"
            />
          </div>
          <div className="p-2">
            <Button
              color="bg-green-500 disabled:bg-gray-300"
              onClick={handleForwardToMoe}
              disabled={loading1 || !holdComment || !holdReason || !holdFile}
              text={!loading1 ? "Forward To MOE" : <Loading />}
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">MOE Hold - Comment & Reason</h2>
              <span
                className="cursor-pointer rounded-full w-8 h-8 bg-red-400 text-white 
                  flex items-center justify-center active:scale-90 hover:bg-red-500 text-sm"
                onClick={() => setShowModal(false)}
              >
                X
              </span>
            </div>

            {modalError && (
              <div className="mb-3">
                <AlertDenger text={modalError} />
              </div>
            )}

            <label className="font-semibold mb-1 block">
              Reason <span className="text-red-500">*</span>
            </label>
            <select
              className="bg-gray-100 rounded-lg p-2 outline-blue-700 border w-full mb-4"
              value={modalReason}
              onChange={(e) => setModalReason(e.target.value)}
            >
              <option value="">-- Select a Reason --</option>
              <option value="Non Licensed School">Non Licensed School</option>
              <option value="Foreign Student">Foreign Student</option>
              <option value="Returned from MOE">Returned from MOE</option>
            </select>

            <label className="font-semibold mb-1 block">
              Comment <span className="text-red-500">*</span>
            </label>
            <textarea
              rows="4"
              placeholder="Write a comment here..."
              className="bg-gray-100 rounded-lg resize-none p-2 outline-blue-700 border w-full mb-4"
              value={modalComment}
              onChange={(e) => setModalComment(e.target.value)}
            ></textarea>

            <label className="font-semibold mb-1 block">Attach PDF File</label>
            <input
              type="file"
              accept="application/pdf"
              className="bg-gray-100 rounded-lg p-2 outline-blue-700 border w-full mb-4"
              onChange={(e) => setModalFile(e.target.files[0])}
            />
            {holdFile && !modalFile && (
              <p className="text-sm text-gray-500 mb-4">
                Current file: <span className="font-semibold">{holdFile}</span>
              </p>
            )}

            <Button
              text={!modalLoading ? "Save" : <Loading />}
              color="bg-blue-500 disabled:bg-gray-300 w-full"
              disabled={modalLoading}
              onClick={handleSaveComment}
            />
          </div>
        </div>
      )}

      {/* PDF Viewer Modal */}
      {showPdfModal && holdFile && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
          onClick={() => setShowPdfModal(false)}
        >
          <div
            className="bg-white rounded-lg w-[90vw] h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="font-bold text-lg">PDF Viewer - {holdFile}</h3>
              <button
                className="text-gray-500 hover:text-red-500 text-2xl font-bold"
                onClick={() => setShowPdfModal(false)}
              >
                &times;
              </button>
            </div>
            {pdfBlobUrl ? (
              <iframe
                src={pdfBlobUrl}
                className="flex-1 w-full"
                title="PDF Viewer"
              />
            ) : (
              <div className="flex-1 flex items-center justify-center">
                <Loading />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
